var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNutzfahrzeug = function SvgNutzfahrzeug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 77 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.66 7a.5.5 0 0 0-.433.252L15.09 19.74A2.5 2.5 0 0 1 12.92 21H9.003A6.03 6.03 0 0 0 3 27.003V31h7.65a7.503 7.503 0 0 1 14.7 0h26.3a7.503 7.503 0 0 1 14.7 0h7.15a.5.5 0 0 0 .5-.5V7H22.66ZM18 40a7.503 7.503 0 0 0 7.35-6h26.3a7.503 7.503 0 0 0 14.7 0h7.15a3.5 3.5 0 0 0 3.5-3.5v-24A2.5 2.5 0 0 0 74.5 4H22.66a3.5 3.5 0 0 0-3.038 1.764L12.63 18H8.994A9.03 9.03 0 0 0 0 26.994V31.5A2.5 2.5 0 0 0 2.5 34h8.15A7.503 7.503 0 0 0 18 40Zm0-12a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Zm36.5 4.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM54 18H21v3h33v-3Z",
    fill: "currentColor"
  })));
};
export default SvgNutzfahrzeug;